import { createContext } from 'react';

// Holds the static page data (dimensions, metrics, operators, formats, ref tables, periods)
// shared by the custom metric form components.
export const CustomMetricsContext = createContext({
    dimensions: [],
    resultOperators: [],
    displayFormatsList: [],
    allMetrics: [],
    visibleMetrics: [],
    refTables: [],
    allResultValues: [],
    cohortPeriods: [],
});
